import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=4785cf9f&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=4785cf9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785cf9f",
  null
  
)

export default component.exports